export type ServiceType = 'depannage' | 'site-web' | 'reparation-telephone' | 'autre';

export interface ContactFormData {
  service: ServiceType | '';
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  city: string;
  budget?: typeof BUDGET_OPTIONS[number]['value'];
  message: string;
  consent: boolean;
}

export const BUDGET_OPTIONS = [
  { value: 'under1k', label: 'Moins de 1 000 €' },
  { value: '1k3k', label: '1 000 € – 3 000 €' },
  { value: '3k5k', label: '3 000 € – 5 000 €' },
  { value: '5kplus', label: 'Plus de 5 000 €' },
  { value: 'unknown', label: 'Je ne sais pas encore' },
] as const;
